/* eslint global-require: "off" */

import { createStore as _createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import createMiddleware from "./middleware/clientMiddleware";

export const configureStore = (history, client, data) => {
  const reduxRouterMiddleware = routerMiddleware(history);
  const middleware = [createMiddleware(client), reduxRouterMiddleware, thunk];

  const composeEnhancers =
    (typeof window === "object" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const finalCreateStore = composeEnhancers(applyMiddleware(...middleware))(
    _createStore
  );

  const reducers = require("./reducers").default;
  const store = finalCreateStore(reducers, data);

  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./reducers", () => {
      store.replaceReducer(require("./reducers").default);
    });
  }

  return store;
};
